<template>
  <div id="plans" class="paths">
    <div class="_1200">
      <h1 class="path-main-head">{{selectedPath.title}}</h1>
      <div class="paths-wrapper">
        <div class="path-box-big">
          <div class="w-richtext" v-html="selectedPath.info"></div>
          <div class="btn-wrapper">
            <a v-if="!getRegistered" href="#" class="btn w-button" @click="pathRegistration()">הרשמה למסלול</a>
            <div v-else>
            <p>אתה רשום למסלול זה</p>
            <router-link :to="'/path/'+this.$route.params.id" class="btn w-button" >המשך למסלול</router-link>
            </div>
          </div>
          <p v-if="this.signInError" class="sign-link" style="color:red">{{ this.getErrMsg }}</p>
          <div style="text-align:center">
            <loader v-if="this.loading" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import { mapActions, mapGetters } from "vuex";
import loader from "../components/loader";

export default {
  name: "path_page",
  components: { loader },
  data() {
    return {
      loading: false,
      signInError: false,
    };
  },
  mounted() {
    this.fetchSelectedPath(this.$route.params.id);
    this.$store.dispatch("isPathInUser");
  },
  methods: {
    ...mapActions(["fetchSelectedPath"]),
    pathRegistration() {
      this.$store.dispatch("registerPath");
      this.$store.dispatch("isPathInUser");
    }
  },
  computed: {
    selectedPath() {
      return this.$store.getters.getSelectedPath;
    },
    // buttonTxt() {
    //   if (this.registered) return "אתה רשום למסלול זה";
    //   else return "הרשמה למסלול";
    // },
    ...mapGetters(["getLoading", "getErrMsg", "getRegistered"])
  },
  watch: {
    getLoading() {
      console.log('getLoading' + this.getLoading.toString());
      switch (this.getLoading) {
        case 1:
          this.loading = true;
          break;
        case 2:
          this.loading = false;
          break;
        case 3:
          this.signInError = true;
          this.loading = false;
          break;
      }
    },

  }
};
</script>

